import { useServices, useCurrentCategoryValue } from '../../../context';
import { useAppNavigation } from '../../../hooks/useAppNavigation';
import { useSpec } from '../../../hooks/useSpec';
import { DomainFlow } from '../../../experiments';
import { setMetasiteError } from '../../../context/errors';
import { useStoreNameData, setStoreNameData } from '../context/storeNameAtoms';
import { CATEGORIES_WITHOUT_COMPONENT_UPDATE } from '@common/constants/categories';
import { DOMAIN_URL, SITE_PREVIEW_URL } from '../../../consts';

export function useStoreLaunch() {
  const { currentStoreName, isAcceptedPayments } = useStoreNameData();
  const { chatServiceDs: chatService, domainService } = useServices();
  const { navigate } = useAppNavigation();
  const selectedCategory = useCurrentCategoryValue();

  const isDomainFlowEnabled = useSpec(DomainFlow);

  function onComplete() {
    if (isDomainFlowEnabled) {
      return navigate(DOMAIN_URL);
    }

    navigate(SITE_PREVIEW_URL);
  }

  async function launchStore() {
    try {
      setStoreNameData({ launchStatus: 'started' });

      if (currentStoreName) {
        await chatService.triggerUpdateSiteSettings();
        if (!CATEGORIES_WITHOUT_COMPONENT_UPDATE.includes(selectedCategory)) {
          await chatService.updateComponent();
        }
        if (isDomainFlowEnabled) {
          await domainService.loadSuggestions(currentStoreName);
        }
      }
      await chatService.publishSite();

      if (isAcceptedPayments) {
        try {
          await chatService.connectPaymentProvider();
        } catch (error) {
          console.error('Failed to connect payment provider:', error);
          // Continue with the flow even if payment connection fails
        }
      }

      await chatService.querySites();
    } catch (error) {
      console.error('Failed to launch store:', error);
      setMetasiteError(true);
    } finally {
      setStoreNameData({ launchStatus: 'completed' });
    }
  }

  return {
    launchStore,
    onComplete,
  };
}
